import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
// Toaster moved to App.jsx
import App from './App.jsx'
// AppProvider moved to App.jsx to ensure proper provider hierarchy
// useApp import removed - no longer needed in main.jsx
import { setupGlobalErrorHandlers } from './utils/errorHandler.js'
import './index.css'

console.log('main.jsx: Starting application initialization...'); // Debug log

// Initialize theme from localStorage
const savedTheme = localStorage.getItem('theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);
console.log('main.jsx: Theme initialized:', savedTheme); // Debug log

// Setup global error handlers
setupGlobalErrorHandlers();
console.log('main.jsx: Global error handlers setup complete'); // Debug log

console.log('main.jsx: About to render React app...'); // Debug log

const rootElement = document.getElementById('root');
console.log('main.jsx: Root element found:', rootElement); // Debug log

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

console.log('main.jsx: React app render call completed'); // Debug log